//假设这里定义用户功能模块的api请求

//一般根据具体的接口服务模块约定
const baseURL = '/api';
const distributionURL = '/api';
const classroomURL = '/api';
import listRequest from '../../js/listRequest.js';

export const materiaApi = {
    //最简单的写法，列表啥也不用做
    getList(opt: any) {
        var servicesPath = distributionURL + '/distribution/course/school';
        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        let pager = opt.pager;
        let initCodeRules = opt.initCodeRules;

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            data: pageData,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            appendAttributes: opt.appendAttributes || {},
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getListV2(opt: any) {
        var servicesPath = distributionURL + `/distribution/school/${opt.data.schoolIdList[0]}`;
        let context = opt.context;
        let pageData = {
            titleOrDesc: opt.data.courseName,
            phases: opt.data.phases,
            source: opt.data.source,
            subject: opt.data.subject
        };
        if (!opt.data.source) {
            delete pageData.source;
        }
        if (!opt.data.subject) {
            delete pageData.subject;
        }
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            data: pageData,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            appendAttributes: opt.appendAttributes || {},
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    getMateriaDetail(opt: any) {
        var servicesPath = baseURL + '/course/published/info';
        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj.id;

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    saveOutAuthorization(opt: any) {
        var servicesPath = distributionURL + '/distribution/class';
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'PUT';

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '保存中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    getClasssBySection(opt: any) {
        var servicesPath = baseURL + '/organization/getClasssBySection';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj.id;
        let data = {
            code: 0,
            data: {
                content: [
                    {
                        name: '一班',
                        checked: true,
                        id: '25702618463795237'
                    },
                    {
                        name: '二班',
                        checked: false,
                        id: '25796489028919083'
                    }
                ]
            }
        };
        opt.success(data, opt);
    },
    CourseIdListInfo(opt: any) {
        var servicesPath = baseURL + '/course/published/courses/info';
        let context = opt.context;

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            data: opt.urlQueryParmas || {},
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getClassList(opt: any) {
        var servicesPath = classroomURL + '/v1/class/list';
        let context = opt.context;
        let pager = opt.pager;
        let initCodeRules = opt.initCodeRules;

        listRequest.request({
            url: servicesPath,
            context: context,
            pager: pager,
            waitingtip: '加载中，请稍等...',
            data: {},
            urlQueryParmas: opt.urlQueryParmas || {},
            getDesc: opt.getDesc || {},
            success(data: any, parameters: any) {
                let groupJson: any = [];
                var result = [];
                for (var i = 0; i < data.data.list.length; i++) {
                    data.data.list[i]['disabled'] = false;
                    if (!groupJson[data.data.list[i].period]) {
                        groupJson[data.data.list[i].period] = [];
                    }
                    groupJson[data.data.list[i].period].push(data.data.list[i]);
                }
                for (var p in groupJson) {
                    var desc = this.getDesc(p, initCodeRules);
                    result.push({
                        section: p,
                        sectionName: desc,
                        classList: groupJson[p]
                    });
                }
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(result, parameters);
                }
            },
            afterRender: opt.afterRender || function() {}
        });
    },
    getcheckboxGroupAndcheckAll(opt: any) {
        var servicesPath = distributionURL + '/distribution/class';
        let context = opt.context;
        let initCodeRules = opt.initCodeRules;
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            data: opt.data || {},
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    courseWithdraw(opt: any) {
        var servicesPath = baseURL + '/course/withdraw';

        let context = opt.context;
        let urlParamObj = opt.urlParamObj || {};
        let pageData = opt.data || {};

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            data: pageData,
            ajaxOpt: {
                //ajax的参数配置
                type: 'POST' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    getClassNameByCourseId(opt: any) {
        var servicesPath = distributionURL + '/distribution/class/list';
        let context = opt.context;
        let initCodeRules = opt.initCodeRules;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        let pager = opt.pager;
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            data: pageData,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 获取课程类型
    getSubjectData(opt: any) {
        var servicesPath = distributionURL + '/course/subjects';
        let context = opt.context;
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 课程管理批量取消课程与班级关联（单个取消也用这个）  http://yapi.dm-ai.cn:3000/project/433/interface/api/26855
    deleteCourseClass(opt: any) {
        var servicesPath = distributionURL + '/distribution/class';
        let context = opt.context;
        let pageData = opt.data || {};
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'DELETE' //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 获取班级该课程的上课状态  http://yapi.dm-ai.cn:3000/project/163/interface/api/27450
    getClassStatus(opt: any) {
        var servicesPath = baseURL + '/v1/class_status/class/count';
        let context = opt.context;
        let pageData = opt.data || {};
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            data: pageData,
            ajaxOpt: {
                //ajax的参数配置
                type: 'POST' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    }
};
